// Breakpoints das media queries
export const breakpoints = {
  xs: '320px',
  sm: '576px',
  md: '769px',
  lg: '992px',
  xl: '1200px'
};
